import { canonicalTeamName } from "./feeRules";

// รายชื่อทีมที่ใช้ร่วมกันทั้งหน้ากรอกค่ากดและหน้าจัดการผู้ใช้
// เก็บไว้ไฟล์เดียวเพื่อไม่ให้ dropdown แต่ละหน้ามีรายชื่อไม่ตรงกัน
export const TEAM_MEMBERS = [
  "ยย", "ลิตเติ้ล", "ม้าค", "เอ", "กอ", "มาย", "ฟิว", "แพร", "บต", "ออ",
  "มัดหมี่", "พตว", "จจ", "ยว", "ปิ่น", "นว", "เจได", "เอ็ม", "น้ำ", "ใบบัว",
  "อั้ย", "โซ่", "แบม", "นข", "พอมอ", "ฟ้า", "เนิฟ", "ฝ้าย", "เจ", "จีจี้",
  "มะเม้ว", "ป่าน", "พี่มาย", "พี่เตย", "เฟย", "จินนี่",
];

export const normalizeTeamMember = (value) => {
  const canonical = canonicalTeamName(value);
  return TEAM_MEMBERS.includes(canonical) ? canonical : "";
};
